import { scrollBarCheck } from '../../../../lib/utils';
import { SIDEBAR_VIEWS, MAP_LAYER_IDS } from '../../../../lib/constants';
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle'
import ExportFeaturesModal from '../../../Modals/ExportFeaturesModal';

export default (dispatch) => ({
  gotoSidebar: (sidebarView) => {
    dispatch({
      type: 'app/gotoSidebar',
      payload: sidebarView
    });
  },
  clearFilters: () => {
    dispatch({
      type: 'features/setFeaturesLoading',
      payload: true
    });
    dispatch({
      type: 'features/resetFiltersAndSort'
    });
    dispatch({
      type: 'features/clearFeatures',
    });
    dispatch({
      type: 'features/getUserDataPoll-start',
      callback: () => {
        dispatch({
          type: 'features/getUserDataPoll-stop',
        });

        dispatch({
          type: 'features/setMoreFeaturesLoading',
          payload: false
        });
      }
    });
  },
  exportAllContent: () => {
    dispatch({
      type: 'modals/add',
      payload: {
        component: ExportFeaturesModal,
      }
    });
  },
  featureClicked: (selectedFeature) => {
    dispatch({
      type: 'features/setSelectedFeatureLoading',
      payload: true
    });
    dispatch({
      type: 'features/setIsEditingFeature',
      payload: false,
    })
    dispatch({
      type: 'app/gotoSidebarWithHistory',
      payload: SIDEBAR_VIEWS.FeatureDetail
    });
    dispatch({
      type: 'features/getFeature',
      payload: selectedFeature.uuid,
      callback: (feature, error) => {
        if (feature) {
          dispatch({
            type: 'features/setSelectedFeature',
            payload: feature
          });
          dispatch({
            type: 'features/setPreviousFeatureState',
            payload: feature
          });
          dispatch({
            type: 'app/setSideBarScrollPosition',
            payload: { features: feature.uuid },
          })
          dispatch({
            type: 'map/goToFeature',
            payload: {
              featureId: feature.uuid,
              layerId: MAP_LAYER_IDS.content
            }
          });
        } else {
          dispatch({
            type: 'app/navSidebarBack'
          });
          dispatch({
            type: 'features/setSelectedFeature',
            payload: null
          });
          let toastPayloadText = 'Oops, there was an issue retrieving the feature'
          if (error.status == 404) {
            toastPayloadText = 'Sorry, but it looks like that feature does not exist'
            dispatch({
              type: 'features/removeFeatureFromUserDataEffect',
              payload: selectedFeature.uuid
            })
          }
          dispatch({
            type: 'toast/show',
            payload: {
              dismissable: true,
              icon: AlertCircle,
              iconColor: '#FF3B30',
              text: toastPayloadText,
            }
          });
        }
        dispatch({
          type: 'features/setSelectedFeatureLoading',
          payload: false
        });
      }
    });
  },
  importContent: () => {
    dispatch({
      type: 'app/gotoSidebar',
      payload: SIDEBAR_VIEWS.DataManager
    });
  },
  toggleVisibilityAll: (visibility) => {
    let dispatchType = 'features/setIsShowingItems'
    if (!visibility) {
      dispatchType = 'features/setIsHidingItems'
    }
    dispatch({
      type: dispatchType,
      payload: true
    });
    setTimeout(() => {
      dispatch({
        type: 'features/setFeaturesVisibility',
        payload: { type: 'all', visibility },
        callback: () => {
          setTimeout(() => {
            dispatch({
              type: dispatchType,
              payload: false
            });
          }, 100)
        }
      });
    }, 100)
  },
  toggleCheckboxAll: (areAllFeaturesSelected) => {
    let dispatchType = 'features/setIsSelectingItems'
    if (areAllFeaturesSelected) {
      dispatchType = 'features/setIsDeselectingItems'
    }
    dispatch({
      type: dispatchType,
      payload: true
    });
    setTimeout(() => {
      dispatch({
        type: 'features/toggleAllCheckboxes',
        payload: !areAllFeaturesSelected,
        callback: () => {
          dispatch({
            type: dispatchType,
            payload: false
          });
        }
      });
    }, 50)
  },
  setHasScrollBar: (id) => {
    const hasScrollBar = scrollBarCheck(id)
		dispatch({
      type: 'app/setSidebarHasScrollBar',
      payload: hasScrollBar
    })
  }
});